export default {
    'zh_CN': {
        'property.jobs-info.id.label': '主键',
        'property.jobs-info.id.holder': '请输入主键',
        
        
        'property.jobs-info.id.required': '主键必填',
        'property.jobs-info.name.label': '名称',
        'property.jobs-info.name.holder': '请输入名称',
        'property.jobs-info.name.max': '名称最多50个字符',
        
        'property.jobs-info.name.required': '名称必填',
        'property.jobs-info.remark.label': '备注',
        'property.jobs-info.remark.holder': '请输入备注',
        'property.jobs-info.remark.max': '备注最多255个字符',
        
        'property.jobs-info.remark.required': '备注必填',
        'property.jobs-info.createTime.label': '创建时间',
        'property.jobs-info.createTime.holder': '请输入创建时间',
        'property.jobs-info.createTime.required': '创建时间必填',
        'property.jobs-info.updateTime.label': '修改时间',
        'property.jobs-info.updateTime.holder': '请输入修改时间',
        'property.jobs-info.updateTime.required': '修改时间必填',
        'property.jobs-info.isDelete.label': '是否删除',
        'property.jobs-info.isDelete.holder': '请输入是否删除',
        
        
        'property.jobs-info.isDelete.dictionary': ()=>[{value:0,label:'删除'}],
        'property.jobs-info.isDelete.required': '是否删除必填'
    },
    'zh_TW': {
        'property.jobs-info.id.label': '主键',
        'property.jobs-info.id.holder': '請輸入主键',
        
        
        'property.jobs-info.id.required': '主键必填',
        'property.jobs-info.name.label': '名称',
        'property.jobs-info.name.holder': '請輸入名称',
        
        
        'property.jobs-info.name.required': '名称必填',
        'property.jobs-info.remark.label': '备注',
        'property.jobs-info.remark.holder': '請輸入备注',
        
        
        'property.jobs-info.remark.required': '备注必填',
        'property.jobs-info.createTime.label': '创建时间',
        'property.jobs-info.createTime.holder': '請輸入创建时间',
        
        
        'property.jobs-info.createTime.required': '创建时间必填',
        'property.jobs-info.updateTime.label': '修改时间',
        'property.jobs-info.updateTime.holder': '請輸入修改时间',
        
        
        'property.jobs-info.updateTime.required': '修改时间必填',
        'property.jobs-info.isDelete.label': '是否删除',
        'property.jobs-info.isDelete.holder': '請輸入是否删除',
        
        
        'property.jobs-info.isDelete.required': '是否删除必填'
    },
    'en_US': {
        'property.jobs-info.id.label': 'id',
        'property.jobs-info.id.holder': 'Enter id',
        'property.jobs-info.id.max': 'id max length: 主键',
        
        
        'property.jobs-info.id.required': 'id required',
        'property.jobs-info.name.label': 'name',
        'property.jobs-info.name.holder': 'Enter name',
        'property.jobs-info.name.max': 'name max length: 名称',
        
        
        'property.jobs-info.name.required': 'name required',
        'property.jobs-info.remark.label': 'remark',
        'property.jobs-info.remark.holder': 'Enter remark',
        'property.jobs-info.remark.max': 'remark max length: 备注',
        
        
        'property.jobs-info.remark.required': 'remark required',
        'property.jobs-info.createTime.label': 'createTime',
        'property.jobs-info.createTime.holder': 'Enter createTime',
        'property.jobs-info.createTime.max': 'createTime max length: 创建时间',
        
        
        'property.jobs-info.createTime.required': 'createTime required',
        'property.jobs-info.updateTime.label': 'updateTime',
        'property.jobs-info.updateTime.holder': 'Enter updateTime',
        'property.jobs-info.updateTime.max': 'updateTime max length: 修改时间',
        
        
        'property.jobs-info.updateTime.required': 'updateTime required',
        'property.jobs-info.isDelete.label': 'isDelete',
        'property.jobs-info.isDelete.holder': 'Enter isDelete',
        'property.jobs-info.isDelete.max': 'isDelete max length: 是否删除',
        
        
        'property.jobs-info.isDelete.required': 'isDelete required'
    }
}
